// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'

/* 路由 */
import router from './router'

/* vuex */
import store from './store' //引用vuex

/* font and icon css */
import './assets/vendor/font-awesome/css/font-awesome.min.css'
// import 'https://fonts.googleapis.com/css?family=Montserrat:400,700'
// import 'https://fonts.googleapis.com/css?family=Playfair+Display:400,400italic,700,700italic'
// import 'https://fonts.googleapis.com/css?family=Raleway:400,700,300'
import './assets/fonts/Stroke-Gap-Icons-Webfont/style.css'



/* components css */
import './assets/vendor/bootstrap/dist/css/bootstrap.min.css'
import './assets/vendor/owl-carousel/owl-carousel/owl.carousel.css'
import './assets/vendor/slider-pro/dist/css/slider-pro.min.css'
import './assets/vendor/slick-carousel/slick/slick.css'
import './assets/vendor/animate.css/animate.min.css'
import './assets/vendor/fancybox/source/jquery.fancybox.css'

import './assets/css/main.css'


/* js */
import './assets/js/jquery-1.11.3.min.js'
import './assets/vendor/jquery-ui/jquery-ui.min.js'
import './assets/vendor/bootstrap/dist/js/bootstrap.min.js'
import './assets/vendor/owl-carousel/owl-carousel/owl.carousel.min.js'
import './assets/vendor/jquery-ui/jquery-ui.min.js'
import './assets/vendor/waypoints/lib/jquery.waypoints.min.js'
import './assets/vendor/slider-pro/dist/js/jquery.sliderPro.min.js'
import './assets/vendor/slick-carousel/slick/slick.min.js'
import './assets/vendor/jquery.mb.ytplayer/dist/jquery.mb.YTPlayer.min.js'
import './assets/vendor/wow/dist/wow.min.js'
import './assets/vendor/fancybox/source/jquery.fancybox.pack.js'
import './assets/js/modernizr.js'

// custom scripts
import './assets/js/custom.js'
// import './assets/js/contact.js'

/* jquery */
import 'jquery'

/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

import TopHeader from './components/TopHeader.vue'
Vue.component(TopHeader.name,TopHeader)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    next();
});

new Vue({
  el: '#app',
  router,
  store, // 注册vuex的store对象  ==> 所有组件对象都有一个$store属性
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js